// extracted by mini-css-extract-plugin
var _1 = "useDocFlowProfileHeaderInfoItems-modulecontentWrapper__e7hCY";
var _2 = "useDocFlowProfileHeaderInfoItems-moduleeditableContentWrapper__XrsL7";
var _3 = "useDocFlowProfileHeaderInfoItems-moduleitemTitle__rPDU2";
var _4 = "useDocFlowProfileHeaderInfoItems-modulerefreshButton__zVAZS";
export { _1 as "contentWrapper", _2 as "editableContentWrapper", _3 as "itemTitle", _4 as "refreshButton" }
